/**
 * Even with flex 1 1 0, flex items with long "words" that can't be broken will cause horizontal scroll.
 * break-words will inherit so we don't always need to respecify it, but the min-w-0 often needs
 * to be set close to the problematic text content.
 */
export const breakWordsContainer = "min-w-0 break-words";
